(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["copilot-centered-video-slider"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
        const lang = document.documentElement.lang || "es";

        // Initialize all video elements inside the slider cards
        document.querySelectorAll(".copilot-centered-card").forEach(card => {
            let src;

            if (lang.startsWith("it")) {
                src = card.dataset.it;
            } else if (lang.startsWith("pt")) {
                src = card.dataset.pt;
            } else {
                src = card.dataset.es;
            }

            const video = card.querySelector("video");
            const btn = card.querySelector(".copilot-centered-card__play");
            const poster = card.querySelector(".copilot-centered-card__poster");

            if (!src || !video) return;

            video.src = src;
            video.muted = true;
            video.playsInline = true;
            video.preload = "metadata";

            function playFullVideo() {
                video.currentTime = 0;
                video.muted = false;
                video.controls = true;
                card.classList.add("playing");

                if (poster) poster.style.opacity = "0";
                if (btn) btn.style.display = "none";

                video.play().catch(() => {});
            }

            function hoverPreviewStart() {
                // Only play preview if item is the active centered item in the slick slider
                const slideParent = card.closest('.slick-slide');
                if (slideParent && !slideParent.classList.contains('slick-center')) return;
                if (window.innerWidth <= 768) return;
                if (card.classList.contains("playing")) return;

                video.muted = true;
                video.controls = false;

                if (poster) poster.style.opacity = "0";
                video.play().catch(() => {});
            }

            function hoverPreviewStop() {
                if (window.innerWidth <= 768) return;
                if (card.classList.contains("playing")) return;

                video.pause();
                video.currentTime = 0;

                if (poster) poster.style.opacity = "";
                if (btn) btn.style.display = "";
            }

            if (btn) {
                btn.addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    playFullVideo();
                });
            }

            if (poster) {
                poster.addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    playFullVideo();
                });
            }

            card.addEventListener("mouseenter", hoverPreviewStart);
            card.addEventListener("mouseleave", hoverPreviewStop);

            video.addEventListener("ended", function () {
                if (card.classList.contains("playing")) {
                    card.classList.remove("playing");
                    video.controls = false;
                    video.muted = true;
                    video.currentTime = 0;

                    if (poster) poster.style.opacity = "";
                    if (btn) btn.style.display = "";
                }
            });
        });
    });

    document.addEventListener("DOMContentLoaded", function () {
        const slider = document.querySelector(".js-centered-video-slider");
        if (!slider || typeof $ === "undefined" || !$.fn.slick) return;

        const prevArrow = `
            <button type="button" class="slick-prev copilot-arrow-btn" aria-label="Anterior">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>
        `;

        const nextArrow = `
            <button type="button" class="slick-next copilot-arrow-btn" aria-label="Siguiente">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
            </button>
        `;

        // Initialize slick centered slider
        const $slider = $(slider);
        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            centerMode: true,
            centerPadding: '10%',
            arrows: true,
            dots: false,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        centerPadding: '6%'
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '50px'
                    }
                }
            ]
        });

        // Reset video play status when changing slides
        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $slider.find('.copilot-centered-card.playing').each(function() {
                const card = this;
                const video = card.querySelector("video");
                const poster = card.querySelector(".copilot-centered-card__poster");
                const btn = card.querySelector(".copilot-centered-card__play");

                card.classList.remove("playing");
                if (video) {
                    video.pause();
                    video.controls = false;
                    video.muted = true;
                    video.currentTime = 0;
                }
                if (poster) poster.style.opacity = "";
                if (btn) btn.style.display = "";
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["copilot-video-stories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const lang = document.documentElement.lang || 'es';

    document.querySelectorAll('.copilot-video-card').forEach((card) => {
      
      let src = card.dataset.es;
      const video = card.querySelector('video');
      const btn = card.querySelector('.copilot-video-card__play');
      const poster = card.querySelector('.copilot-video-card__poster');

      if (!src) return;

      video.src = src;
      video.muted = true;
      video.playsInline = true;
      video.preload = 'metadata';

      function playFullVideo() {
        video.currentTime = 0;
        video.muted = false;
        video.controls = true;
        card.classList.add('playing');

        if (poster) poster.style.display = 'none';
        if (btn) btn.style.display = 'none';

        video.play().catch(() => {});
      }

      function hoverPreviewStart() {
        if (window.innerWidth <= 768) return;
        if (card.classList.contains('playing')) return;

        video.muted = true;
        video.controls = false;

        if (poster) poster.style.display = 'none';
        //if (btn) btn.style.display = "none";

        video.play().catch(() => {});
      }

      function hoverPreviewStop() {
        if (window.innerWidth <= 768) return;
        if (card.classList.contains('playing')) return;

        video.pause();
        video.currentTime = 0;

        if (poster) poster.style.display = '';
        if (btn) btn.style.display = '';
      }

      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          playFullVideo();
        });
      }

      if (poster) {
        poster.addEventListener('click', function () {
          playFullVideo();
        });
      }

      card.addEventListener('mouseenter', hoverPreviewStart);
      card.addEventListener('mouseleave', hoverPreviewStop);

      video.addEventListener('ended', function () {
        if (card.classList.contains('playing')) {
          card.classList.remove('playing');
          video.controls = false;
          video.muted = true;
          video.currentTime = 0;

          if (poster) poster.style.display = '';
          if (btn) btn.style.display = '';
        }
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    var slider = document.querySelector('.js-video-slider');
    var bulletsWrap = document.querySelector('.js-video-bullets');
    if (!slider || !bulletsWrap) return;

    var cards = slider.querySelectorAll('.copilot-video-card');
    var total = cards.length;
    var dots = [];
    var currentIndex = 0;
    var scrollListener = null;

    function isMobile() { return window.innerWidth <= 768; }

    function buildBullets() {
      bulletsWrap.innerHTML = '';
      dots = [];
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.className = 'js-video-bullet';
        dot.setAttribute('aria-label', 'Ir a video ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function () { goTo(idx); });
        })(i);
        bulletsWrap.appendChild(dot);
        dots.push(dot);
      }
      updateBullets(0);
    }

    function updateBullets(idx) {
      currentIndex = idx;
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    function goTo(idx) {
      var cardWidth = cards[0].getBoundingClientRect().width;
      slider.scrollTo({ left: cardWidth * idx, behavior: 'smooth' });
    }

    function onScroll() {
      var cardWidth = cards[0].getBoundingClientRect().width || slider.offsetWidth;
      var idx = Math.round(slider.scrollLeft / cardWidth);
      idx = Math.max(0, Math.min(idx, total - 1));
      if (idx !== currentIndex) updateBullets(idx);
    }

    function setup() {
      if (isMobile() && total > 1) {
        bulletsWrap.style.display = 'flex';
        buildBullets();
        if (!scrollListener) {
          scrollListener = onScroll;
          slider.addEventListener('scroll', scrollListener, { passive: true });
        }
      } else {
        bulletsWrap.style.display = 'none';
        if (scrollListener) {
          slider.removeEventListener('scroll', scrollListener);
          scrollListener = null;
        }
      }
    }

    setup();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setup, 150);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
